export default "__VITE_ASSET__hZBxBD8F__"